import BillingInfo from "./BillingInfo";

export default BillingInfo;